import type { SitePromoBannerCampaign } from './site-promo-banner';

// Change this value in a PR to publish a campaign. Use a new ID for each campaign
// so a visitor who dismissed an older one can see the new message. Use explicit
// UTC timestamps. The start is inclusive and expiration is exclusive.
// Example:
// {
//   id: 'fall-offer-2026',
//   message: 'Explore your selling options with Opendoor.',
//   link: { label: 'Learn more', href: '/cash-now-more-later' },
//   mobile: { message: 'More ways to sell', linkLabel: 'Explore' },
//   variant: 'brand', // Optional. Omit for the quiet strip.
//   linkStyle: 'button', // Optional. Omit for the inline text link.
//   startsAt: '2026-10-01T00:00:00Z',
//   expiresAt: '2026-10-08T00:00:00Z',
//   include: [
//     { path: '/', match: 'exact' },
//     { path: '/homes', match: 'subtree' },
//     { path: '/mortgage', match: 'exact' },
//     { path: '/properties', match: 'subtree' }, // Cosmos property detail pages
//     { path: '/articles/topic/buy', match: 'exact' },
//     { path: '/articles/topic/mortgage', match: 'exact' },
//     { articleKeyword: 'buyers' }, // Beacon articles tagged for the Buy topic
//     { articleKeyword: 'mortgage' }, // Beacon articles tagged for the Mortgage topic
//   ],
// }
// Mobile message: 44 characters max. Mobile link label: 10 max. A text link shows its
// label beside the message, so message and label combined: 28 max.
// Preview a campaign at 320px before merging; character counts do not guarantee fit.
// Set null in a PR to turn the banner off before it expires.
// Preview fixture for the draft Beacon staging PR. Do not merge this campaign
// until the rate, APR, eligibility, disclosure, and launch window are approved.
export const SITE_PROMO_BANNER: SitePromoBannerCampaign | null = {
  id: 'drop-499-preview-2026-10',
  message: 'Make your move now: Get 4.99% 5/6 ARM on select Opendoor homes.',
  link: { label: 'See homes', href: '/drop' },
  mobile: { message: 'Move now: 4.99% 5/6 ARM on select homes.', linkLabel: 'See homes' },
  variant: 'brand',
  linkStyle: 'button',
  startsAt: '2026-10-08T15:00:00-04:00',
  expiresAt: '2026-10-14T15:00:00-04:00',
  include: [
    { path: '/', match: 'exact' },
    { path: '/homes', match: 'subtree' },
    { path: '/mortgage', match: 'exact' },
    { path: '/properties', match: 'subtree' },
    { path: '/articles/topic/buy', match: 'exact' },
    { path: '/articles/topic/mortgage', match: 'exact' },
    { articleKeyword: 'buyers' },
    { articleKeyword: 'mortgage' },
  ],
};

// Mortgage articles retain their generic link outside the numeric campaign.
export const MORTGAGE_ARTICLE_DROPS_BANNER: SitePromoBannerCampaign = {
  id: 'mortgage-articles-drops',
  message: 'Explore special mortgage offers on select Opendoor homes.',
  link: { label: 'Explore Drops', href: '/drop' },
  mobile: { message: 'Special mortgage offers on select homes.', linkLabel: 'See Drops' },
  variant: 'brand',
  linkStyle: 'button',
  include: [{ path: '/articles/topic/mortgage', match: 'exact' }, { articleKeyword: 'mortgage' }],
};
